export default {
  accessRight: "AccessRight",
};
